import { Box, Typography } from '@mui/material';

type Props = {
  isDemo: boolean;
};

// Exposed as a CSS variable so fixed-position AppBars can offset their `top`
// and avoid being obscured by the banner. Consumers read
// `top: var(--app-banner-height, 0px)`.
export const DEMO_BANNER_HEIGHT_PX = 32;

export const DemoBanner = ({ isDemo }: Props) => {
  if (!isDemo) {
    return null;
  }
  return (
    <Box
      role="status"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: `${DEMO_BANNER_HEIGHT_PX}px`,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        backgroundColor: 'warning.main',
        color: 'warning.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Typography variant="body2" component="span">
        Demo Mode — payments and orders are simulated.
      </Typography>
    </Box>
  );
};
